import { useState, useEffect } from 'react';
import "./UpdateTagsModal.css";
import Modal from "../shared/Modal";
import { useSelector } from 'react-redux';
import { selectForms, selectTags } from '../../redux/features/appData';
import { FormExtended, Tag, TagExtended, UpdateFormTagsPayload } from 'effno-core';
import { apiUpdateFormTags } from '../../services/FormService';

type UpdateTagsModalProps = {
    isOpen: boolean;
    formId: string;
    onClose: () => void;
    onSubmit: () => void;
}

export const UpdateTagsModal = ({isOpen, formId, onClose, onSubmit}: UpdateTagsModalProps) => {

    const storeForms = useSelector(selectForms);
    const storeTags = useSelector(selectTags);
    
    const [form, setForm] = useState<FormExtended | undefined>(undefined);
    const [selectedTagIds, setSelectedTagIds] = useState<string[]>([]);

    useEffect(() => {
        if (!storeForms) {
            return;
        }

        const form = storeForms.find(form => form.id === formId);

        setForm(form);
        setSelectedTagIds(form?.tags ? form.tags.map((tag: Tag) => {return tag.id}) : []);

    }, [storeForms]);

    const handleSubmit = async () => {
        if (!form) {
            return;
        }

        const payload : UpdateFormTagsPayload = {
            formId,
            tagIds: selectedTagIds
        }

        await apiUpdateFormTags(payload);

        onSubmit();
    }

    return (
        <>
            {form && 
                <Modal
                    isOpen={isOpen}
                    style={null}
                    onClose={onClose}
                    canClose={true}
                    allowClickout={true}
                >
                    <div className="update-tags-container">
                        <div className="modal-title">
                            Tags for {form?.name}
                        </div>
                        <div className="update-tags-taglist">
                            {storeTags && storeTags.map(tag => {
                                return (
                                    <div 
                                        key={"update-tag-" + tag.id}
                                        className="update-tags-tag"
                                        style={{
                                            backgroundColor: selectedTagIds.includes(tag.id) ? "black" : "white",
                                            color: selectedTagIds.includes(tag.id) ? "white" : "black"
                                        }}
                                        onClick={() => {
                                            if (selectedTagIds.includes(tag.id)) {
                                                setSelectedTagIds(selectedTagIds.filter(id => id !== tag.id));
                                            } else {
                                                setSelectedTagIds([...selectedTagIds, tag.id]);
                                            }
                                        }}
                                    >
                                        {tag.name}
                                    </div>
                                )
                            })}
                        </div>
                        
                        <div className="modal-buttons">
                            <button 
                                className="button-cancel"
                                onClick={onClose}
                            >
                                Cancel
                            </button>
                            <button
                                className="button-save"
                                onClick={handleSubmit}
                            >
                                Submit
                            </button>
                        </div>
                        

                    </div>
                </Modal>
            }
        </>
    )
}